var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSlice } from '@reduxjs/toolkit';
import { userSlice } from './UserStore';
import { loadingSlice } from './LoadingStore';
export var defaultCollectionState = {
    lastRequested: null, // possibly use this to trigger reloading?
    requestError: false,
    pageSize: 10,
    page: 1,
    total: 0,
    collections: [],
};
var getCollectionReducer = function (state, action) {
    // 1. Fallback to page 1 if the API provides 0, null, or undefined to prevent negative math
    var _a = action.payload || {}, newCollections = _a.data, rawPage = _a.current_page, total = _a.total;
    var page = Math.max(1, rawPage || 1);
    if (newCollections) {
        // 2. Clone the array before modifying its length so we don't mutate the raw action payload
        var sanitizedNewCollections = __spreadArray([], newCollections, true);
        if (sanitizedNewCollections.length > state.pageSize) {
            sanitizedNewCollections.length = state.pageSize;
        }
        // Merge newCollections in existing collections making sure that they're slotted in the
        // right place (potentially overwriting existing records if the API messed up)
        var collections = __spreadArray([], state.collections, true);
        // 3. This math is now guaranteed to be 0 or higher, preventing the RangeError
        collections.length = state.pageSize * (page - 1);
        collections.push.apply(collections, sanitizedNewCollections);
        collections = collections.filter(function (item) { return item && (item === null || item === void 0 ? void 0 : item.game_board_id); });
        return __assign(__assign({}, state), { lastRequested: Date.now(), collections: collections, page: page, total: total, requestError: false });
    }
    else {
        return state;
    }
};
var resetReducer = function () {
    return __assign({}, defaultCollectionState);
};
var clearCollectionReducer = function () {
    return defaultCollectionState;
};
var setRequestErrorReducer = function (state) {
    return __assign(__assign({}, state), { lastRequested: Date.now(), requestError: true });
};
export var collectionSlice = createSlice({
    name: 'collection',
    initialState: defaultCollectionState,
    reducers: {
        getCollections: getCollectionReducer,
        clearCollection: clearCollectionReducer,
        setRequestError: setRequestErrorReducer,
        reset: resetReducer,
    },
    extraReducers: function (builder) {
        builder.addCase(userSlice.actions.logout, function () {
            return defaultCollectionState;
        });
    },
});
// ACTUAL ACTIONS
// a place to make the actions more complex if necessary
var getCollections = function (dispatch, payload, apiClient) { return __awaiter(void 0, void 0, void 0, function () {
    var result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(loadingSlice.actions.setLoading({ action: 'getCollection' }));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                return [4 /*yield*/, apiClient().getCollections(payload)];
            case 2:
                result = _a.sent();
                dispatch(collectionSlice.actions.getCollections(result));
                return [3 /*break*/, 5];
            case 3:
                error_1 = _a.sent();
                console.error(error_1);
                dispatch(collectionSlice.actions.setRequestError());
                return [3 /*break*/, 5];
            case 4:
                dispatch(loadingSlice.actions.unsetLoading({ action: 'getCollection' }));
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
//actions that get exported to the views
export var collectionActions = function (dispatch, apiClient) {
    return {
        getCollections: function (payload) { return getCollections(dispatch, payload, apiClient); },
        clearCollections: function () { return dispatch(collectionSlice.actions.clearCollection()); },
        reset: function () { return dispatch(collectionSlice.actions.reset()); },
    };
};
